import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GetHelpDialogComponent } from 'src/app/shared/components/get-help-dialog/get-help-dialog.component';
import { LoaderOverlayService } from 'src/app/core/services/loader-overlay.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { CmsService } from '../../services/cms.service';
import { StoreService } from '../../services/store.service';
import { MenuService } from '../../services/menu.service';
import { ViewCartService } from '../../services/view-cart.service';
import { StorageService } from '../../services/storage.service';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { ForceLogoutDialogComponent } from 'src/app/shared/components/force-logout-dialog/force-logout-dialog.component';
import { Title } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as LZString from 'lz-string';
declare var dataLayer;
@Component({
  selector: 'app-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss']
})
export class LoginDialogComponent implements OnInit, OnDestroy {
  public title = 'Login | Tata Starbucks'
  public loginFormGroup: FormGroup;
  public showErrorMsg: boolean = false;
  public loader: boolean = false;
  public storeList: any;
  public noStoreFound: any;
  public isClicked: boolean;
  public isForceLogin: number = 0;
  public bristaMessage: any;
  public resultLatLong;
  public endsubs$: Subject<any> = new Subject();
  public userType: string;
  public userId: any;
  public tierType: any;
  public isdynamicMenu: boolean
  public isManuallySelectedStore: boolean;
  public workingStoreOnline: any = [];
  public geoResult;
  constructor(
    private dialog: MatDialog,
    public router: Router,
    private titleService: Title,
    private dialogRef: MatDialogRef<LoginDialogComponent>,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    private loaderOverlayService: LoaderOverlayService,
    private cmsService: CmsService,
    private viewCartService: ViewCartService,
    private storeService: StoreService,
    private commonFunction: CommonFunctions,
    private menuService: MenuService,
    private storageService: StorageService,
    private encryptDecryptService: EncryptDecryptService,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.isdynamicMenu = JSON.parse(sessionStorage.getItem('isdynamicMenu'));
    this.isManuallySelectedStore = JSON.parse(localStorage.getItem('isManuallySelectedStore'));
    this.resultLatLong = this.storageService.getLatLongData();
    this.checkLogout();
    if (data === 'splash') {
      this.constructorItem();
    }
    this.buildLoginForm();
    this.titleService.setTitle(this.title);
    this.userType = this.commonFunction.getUserType();
    this.userId = this.commonFunction.getUserId();
    this.tierType = this.commonFunction.getTierType();
  }
  ngOnInit(): void {
    this.onInItData()
  }
  onInItData() {
    let cohortData = JSON.parse(localStorage.getItem('cohortData'));
    if (cohortData) {
      cohortData.baristaContent.forEach(element => {
        if (element.data == 'Pay') {
          this.bristaMessage = element.content && element.content[0];
        }
      });
    }
  }
  constructorItem() {
    let visit = this.storageService.getVisit();
    sessionStorage.clear();
    this.menuService.clearReorderMenuCache();
    this.storeService.clearStoreList();
    sessionStorage.setItem('showBarista', 'yes');
    sessionStorage.removeItem('favouriteItem');
    sessionStorage.removeItem('previosPage');
    sessionStorage.removeItem('defaultSelectionsFav');
    sessionStorage.removeItem('defaultSelections');
    this.checkSnackBar();
    localStorage.removeItem('manualCouponCode');
    this.setPrevVisit(visit);
  }
  setGPSData(result) {
    sessionStorage.setItem('currentLat', result.currentLat);
    sessionStorage.setItem('currentLong', result.currentLong);
    sessionStorage.setItem('locationAccepted', JSON.stringify(true));
    sessionStorage.setItem('gpsEvent', 'granted');
  }
  buildLoginForm() {
    this.loginFormGroup = this.formBuilder.group({
      emailOrMobile: ['', Validators.required],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(50)]],
    });
  }
  public userLogin(): void {
    let formData = this.loginFormGroup.value;
    if (this.loginFormGroup.valid) {
      let firebaseDeviceId = localStorage.getItem('firebaseDeviceId');
      let request = {
        "username": this.encryptDecryptService.encryptData(formData.emailOrMobile),
        "password": this.encryptDecryptService.encryptData(formData.password),
        "deviceToken": firebaseDeviceId ? firebaseDeviceId : '',
        "forceLogin": this.isForceLogin
      }
      this.loader = true;
      this.isClicked = this.loaderOverlayService.showShimmerBtn();
      this.auth.userLogin(request).subscribe((loginResponse) => {
        if (loginResponse.status == 200) {
          this.loader = false;
          this.loginGA();
          if (this.data === 'splash') {
            this.removeData();
            this.storageService.setSessionTokens(loginResponse);
            this.secureLogin();
          }
          if (this.data === 'order') {
            this.removeData();
            this.storageService.setSessionTokens(loginResponse);
            this.secureLogin();
          }
          if (this.data && this.data['redirectTo'] === '/pay') {
            this.removeGuestData();
            this.storageService.setSessionTokens(loginResponse);
            this.secureLoginPay();
          }
          if (this.data['redirectTo'] === '/add-card') {
            this.removeGuestData();
            this.storageService.setSessionTokens(loginResponse);
            this.secureLoginPay();
          }
          if (this.data === 'cart') {
            this.storageService.setSessionTokens(loginResponse);
            this.secureLoginCart();
          }
          if (!this.data) {
            let module = sessionStorage.getItem('module');
            if (module === 'cart') {
              this.storageService.setSessionTokens(loginResponse);
              this.secureLoginCart();
            }
          }
        }
      }, (error: any) => {
        this.loader = false;
        this.isClicked = this.loaderOverlayService.hideShimmerBtn();
        if (error.error.status == 400 || error.error.status == 500) {
          this.loginFormGroup.get('password').reset();
          this.commonFunction.displaySnackBarMessage(error.error.response[0], 'failure')
        } else if (error.error.status == 403) {
          this.openForceLogoutDialog();
        }
      })
    }
  }
  onCloseClick(): void {
    if (this.data && this.data['redirectTo'] === '/pay') {
      this.router.navigate(['/pay']);
      this.updateCart();
    } else if (this.data === 'cart') {
      sessionStorage.setItem('updateCart', 'true');
      this.dialogRef.close();
    } else if (this.data === 'splash') {
      let visit = this.storageService.getVisit();
    }
    setTimeout(() => {
      this.dialogRef.close(this.data);
    }, 30);
  }
  public updateCart() {
    let basketId = this.storageService.getBasketId();
    if (basketId) {
      let resquestPayload = {
        'basketId': basketId
      }
      this.viewCartService.updateBasket(resquestPayload).subscribe((response) => {
        this.itemInCart();
      })
    }
  }
  public itemInCart() {
    let basketId = this.storageService.getBasketId();
    if (basketId) {
      let data = {
        'basketId': basketId
      }
      this.viewCartService.getbasketItem(data).subscribe(res => {
        localStorage.setItem('snackbarData', JSON.stringify(res));
      }, (error) => {
      })
    }
  }
  openGetHelpDailog(): void {
    const dialogRef = this.dialog.open(GetHelpDialogComponent, {
      disableClose: true,
      panelClass: 'getHelp-dialog-box'
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  setPrevVisit(visit) {
    if (visit) {
      this.storageService.setVisit();
    }
  }
  continueAsGuest() {
    this.dialogRef.close('guest');
  }
  public getCohortContent() {
    this.cmsService.getCmsCohortContent().subscribe((response) => {
      localStorage.removeItem('cohortData');
      localStorage.setItem('cohortData', JSON.stringify(response['response']));
    })
  }
  public getCohortContentLogin() {
    this.cmsService.getCmsCohortContent().subscribe((response) => {
      localStorage.removeItem('cohortData');
      localStorage.setItem('cohortData', JSON.stringify(response['response']));
      this.isClicked = this.loaderOverlayService.hideShimmerBtn();
      this.onCloseClick();
    }, (error) => {
      this.onCloseClick();
    })
  }
  public currentStoreId;
  favProducts() {
    this.menuService.getFavMenuItemCache().subscribe(res => {
      sessionStorage.setItem('favouriteItem', JSON.stringify(res['response']));
    })
  }
  checkLogout() {
    let logout = JSON.parse(sessionStorage.getItem('logOut'));
    if (logout) {
    } else {
      let isLoggedIn = this.commonFunction.verifyLoggedInUser();
      if (isLoggedIn) {
        this.router.navigate(['/ordering']);
        this.dialogRef.close();
      } else {
      }
    }
  }
  secureLogin() {
    this.getCohortContentLogin();
    this.favProducts();
  }
  secureLoginPay() {
    let ssid = sessionStorage.getItem('storeId');
    this.currentStoreId ? this.currentStoreId : this.currentStoreId = ssid;
    this.getCohortContentLogin();
    this.favProducts();
  }
  secureLoginCart() {
    let ssid = sessionStorage.getItem('storeId');
    this.currentStoreId ? this.currentStoreId : this.currentStoreId = ssid;
    this.getCohortContentLogin();
    this.favProducts();
  }
  setState() {
    let allMenu = localStorage.getItem('menuListItem') ? JSON.parse(LZString.decompress(localStorage.getItem('menuListItem'))) : '';
    let store = 'noStore'
    let state = {
      data: allMenu ? allMenu : [],
      storeDetails: this.workingStoreOnline ? this.workingStoreOnline : store,
      module: 'breadcrumb'
    };
    this.storageService.setState(state)
  }
  removeGuestData() {
    localStorage.removeItem('paymentModeDetails');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('user_profile');
    localStorage.removeItem('referral_code');
    this.clearHomeMenuFavList();
  }
  removeData() {
    localStorage.removeItem('paymentModeDetails');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_type');
    localStorage.removeItem('user_profile');
    localStorage.removeItem('referral_code');
    this.checkSnackBar();
    localStorage.removeItem('manualCouponCode');
    this.clearHomeMenuFavList();
  }
  checkSnackBar() {
    if (this.data === 'cart') {
    } else {
      localStorage.removeItem('snackbarData');
    }
  }
  clearHomeMenuFavList() {
    this.menuService.clearReorderMenuCache();
    this.menuService.clearFavItemCache();
    this.menuService.clearMenuList();
    this.storeService.clearStoreList();
  }
  public openForceLogoutDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'force-logout-dialog';
    dialogConfig.data = 'test';
    dialogConfig.disableClose = true;
    const dialogRef = this.dialog.open(ForceLogoutDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result == 'YES') {
        this.isForceLogin = 1;
        this.userLogin();
      } else if (result == 'NO') {
      }
    });
  }
  public getactivebasket() {
        this.viewCartService.getActiveBasket()
      .pipe(takeUntil(this.endsubs$)).subscribe((res) => {
        if (!res['response']['basketId']) {
        } else {
          let basketId = res['response']['basketId'];
          sessionStorage.setItem('basketId', basketId);
        }
      }, (error) => {
      })
  }
  ngOnDestroy() {
    this.endsubs$.next();
    this.endsubs$.complete();
  }
  skipGA() {
    dataLayer.push({
      'event': 'login_username_skip_click',
      'userID': this.userId,
      'user_type': this.userType
    })
  }
  loginGA() {
    dataLayer.push({
      'event': 'login_username_password_click',
      'userID': this.userId,
      'user_type': this.userType
    })
  }
  getHelpGA() {
    dataLayer.push({
      'event': 'login_username_get_help_click',
      'userID': 'NA',
      'user_type': this.userType
    })
  }
  signUpGA() {
    dataLayer.push({
      'event': 'login_username_sign_up_click',
      'userID': this.userId,
      'user_type': this.userType
    })
  }
  continueAsGuestGA() {
    dataLayer.push({
      'event': 'guest_user_continue_as_guest_click',
      'userID': this.userId,
      'user_type': this.userType,
      'tier': this.tierType
    })
  }
}
